// extracted by mini-css-extract-plugin
module.exports = {"scanLocationCode":"ManualDescribe_scanLocationCode__1kDY3","qrScanButton":"ManualDescribe_qrScanButton__2q7Sl"};